import type { LocalizedString } from '@cue/api';
import { remove } from 'remove-accents';

export function matchesLocalizedResourceName(
  localizedString: LocalizedString | null | undefined,
  searchText: string,
  currentLanguage: string,
  defaultLanguage: string
): boolean {
  if (!localizedString) {
    return false;
  }

  const localizedValue =
    localizedString[currentLanguage] ??
    localizedString[defaultLanguage] ??
    localizedString['default'] ??
    localizedString['ɵvalue'] ??
    '';

  return normalize(localizedValue).includes(normalize(searchText));
}

function normalize(value: string): string {
  return remove(value).toLowerCase();
}
